"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Convenience class used to write chunks
 */
class Writer {
    constructor(options) {
        this.indents = 0;
        this.write = options.write;
        this.end = options.end;
    }
    indent() {
        this.indents += 1;
        return this;
    }
    deindent() {
        if (this.indents < 1) {
            throw new Error(`Trying to deindent when indent is only ${this.indents}`);
        }
        this.indents -= 1;
        return this;
    }
    add(s, newLine = false) {
        this.write(newLine ? `\n${'\t'.repeat(this.indents)}${s}` : s, 'utf-8');
        return this;
    }
    newLine(no = 2) {
        this.write('\n'.repeat(no) + '\t'.repeat(this.indents), 'utf-8');
        return this;
    }
}
exports.default = Writer;
